export const delayPromiser = (ms) => {
  let timeoutId;
  const delayPromise = new Promise((resolve) => {
    timeoutId = setTimeout(resolve, ms);
  });
  delayPromise.clear = () => clearTimeout(timeoutId);
  return delayPromise;
};

export const delayFunction = (bypass = false, requestFunction = () => new Promise(), ...args) => {
  return new Promise((resolve, reject) => {
    if (!bypass) {
      const timerScoped = setTimeout(() => {
        requestFunction(...args)
          .then(({ isOk }) => {
            resolve(isOk);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            clearTimeout(timerScoped);
          });
      }, 4100);
    } else {
      resolve(true);
    }
  });
};
